import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import QuantityList     from './QuantityList'
import ProductList      from './ProductList'
import PriceList        from './PriceList'

import styles from './Overview.module.css';


@inject('core')
@observer
export default class NewStoreButton extends React.Component {
	
	constructor(props) {
		super(props)
		this.click  = this.click.bind(this)
	}
	
	componentDidMount() {
		const { core } = this.props
	}
	
	click() {
		const { core } = this.props
		
		name = window.prompt('Store Name', '')
		if ((typeof name !== 'undefined') && (name !== 'null') && (name.length)) {
			const uuid = core.uuid('s')
			core.action({
				op:'addStore', 
				store_id: uuid, 
				name: name
			})
		}
	}

	render() {
		const { core } = this.props
		
		return <span className="inline-button" onClick={this.click}>+ New Store</span>
	}
	
}
